import { Link } from "react-router-dom";
import { comics, latestSlugs } from "@/mocks/comics";
import ComicCard from "@/components/base/ComicCard";

export default function LatestSection() {
  const latest = latestSlugs.map((slug) => comics.find((c) => c.slug === slug)).filter(Boolean) as typeof comics;

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">最新上架的韩漫作品，热门连载实时追踪</p>
          </div>
          <Link to="/category/fantasy" className="text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap flex items-center gap-1 transition-colors">
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
          {latest.map((comic) => (
            <ComicCard key={comic.id} comic={comic} />
          ))}
        </div>
      </div>
    </section>
  );
}